/** Default page size for activity log. */
export const ACTIVITY_PAGE_SIZE = 50;

/** Default retention period in days. */
export const ACTIVITY_RETENTION_DAYS = 30;
